import { HiverMultiSelect } from "@hiver/hiver-react-component-library";
import React, { useEffect, useState } from "react";
import SVGInline from "react-svg-inline";
import {
  CUSTOM_FIELD_FILTER_KEY,
  OPERATOR_KEYS,
} from "../../../constants/conversationFilter";
import { cancelBtnStyle, donebtnStyle, iconStyles } from "./styles";
const ButtonsProps = [
  {
    content: "Cancel",
    style: { ...cancelBtnStyle },
    hoverStyle: cancelBtnStyle.hover,
    value: "cancel",
  },
  {
    content: "Done",
    value: "done",
    disabled: false,
    style: { ...donebtnStyle },
    hoverStyle: donebtnStyle.hover,
  },
];

export const FilterMultiSelect = ({
  menuList,
  icon,
  label,
  filterKey,
  customFieldData,
  selectedFilter,
  setSelectedFilter,
  selectedList,
  setSelectedList,
  extraDropdownComponents,
}) => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const [currSelectedItems, setCurrSelectedItems] = useState([]);

  useEffect(() => {
    if (selectedFilter !== filterKey) {
      setOpenDropdown(false);
      setCurrSelectedItems(selectedList);
    }
  }, [selectedFilter]);

  const handleDropdown = () => {
    if (openDropdown) {
      setCurrSelectedItems(selectedList);
    } else {
      setSelectedFilter(filterKey);
    }
    setOpenDropdown(!openDropdown);
    return openDropdown;
  };

  const handleSelectedChanged = (selected = []) => {
    if (!openDropdown) {
      setSelectedFilter(filterKey);
      setOpenDropdown(true);
    }
    setCurrSelectedItems(selected);
  };

  const onButtonClicked = (buttonType, isOnlyButton, onlyValues) => {
    if (isOnlyButton) {
      setCurrSelectedItems(onlyValues);
      setSelectedList({
        name: filterKey,
        op: OPERATOR_KEYS.ANY,
        values: onlyValues,
        custom_field_id: customFieldData?.cf_id,
      });
    } else if (buttonType === "done") {
      setSelectedList({
        name: filterKey,
        op: OPERATOR_KEYS.ANY,
        values: currSelectedItems,
        custom_field_id: customFieldData?.cf_id,
      });
    } else {
      setCurrSelectedItems(selectedList);
    }
    setOpenDropdown(false);
  };

  return (
    <HiverMultiSelect
      rootStyle={{ width: "100%" }}
      dropdownStyle={{ width: "90%" }}
      placeholder="Any"
      label={label}
      menuData={menuList}
      icon={
        icon && (
          <SVGInline
            svg={icon}
            style={iconStyles[filterKey]}
            width={filterKey === CUSTOM_FIELD_FILTER_KEY ? "20px" : "16px"}
            height={filterKey === CUSTOM_FIELD_FILTER_KEY ? "20px" : "14px"}
          />
        )
      }
      openDropdown={handleDropdown}
      open={openDropdown}
      selected={currSelectedItems}
      disabled={false}
      error={false}
      onSelectedChange={handleSelectedChanged}
      buttons={ButtonsProps}
      emptyStateMessage="No results found"
      showOnlyAction={true}
      onSelectAction={onButtonClicked}
      extraDropdownComponents={extraDropdownComponents}
      nameKey="name"
      valueKey="value"
    />
  );
};
